import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CLEAR_USER_SEARCH_STATE } from '../users/UsersReducer';
import {
  CLEAR_DEALER_SEARCH_STATE,
  CLEAR_DEALERS_SELECT_SEARCH_STATE,
} from '../dealers/DealersReducer';
import { CLEAR_ADMIN_SEARCH_STATE } from '../admins/AdminsReducer';
import { CLEAR_VEHICLE_SEARCH_STATE } from '../vehicles/VehicleReducer';
import { CLEAR_GROUP_SEARCH_STATE } from '../groups/GroupsReducer';
import { CLEAR_SELECTED_CHANGE_REQUEST } from '../requestforchanges/RequestFormChangesReducer';
import { CLEAR_BIDS_SEARCH_PARAMS } from '../bids/BidsReducer';

const StateCleaner = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    clearUsersStateIfNeed(pathname, dispatch);
    clearDealersStateIfNeed(pathname, dispatch);
    clearAdminsStateIfNeed(pathname, dispatch);
    clearVehiclesStateIfNeed(pathname, dispatch);
    clearGroupsStateIfNeed(pathname, dispatch);
    clearChangesStateIfNeed(pathname, dispatch);
    clearBidsStateIfNeed(pathname, dispatch);
  }, [location, dispatch]);

  return null;
};

export default StateCleaner;

function clearUsersStateIfNeed(pathname, dispatch) {
  if (!pathname.startsWith('/user')) {
    dispatch({ type: CLEAR_USER_SEARCH_STATE });
  }
}

function clearDealersStateIfNeed(pathname, dispatch) {
  if (!pathname.startsWith('/dealers')) {
    dispatch({ type: CLEAR_DEALER_SEARCH_STATE });
    dispatch({ type: CLEAR_DEALERS_SELECT_SEARCH_STATE });
  }
}

function clearAdminsStateIfNeed(pathname, dispatch) {
  if (!pathname.startsWith('/admin')) {
    dispatch({ type: CLEAR_ADMIN_SEARCH_STATE });
  }
}

function clearVehiclesStateIfNeed(pathname, dispatch) {
  if (!pathname.startsWith('/vehicle')) {
    dispatch({ type: CLEAR_VEHICLE_SEARCH_STATE });
  }
}

function clearGroupsStateIfNeed(pathname, dispatch) {
  if (!pathname.startsWith('/group')) {
    dispatch({ type: CLEAR_GROUP_SEARCH_STATE });
  }
}

function clearChangesStateIfNeed(pathname, dispatch) {
  if (
    !pathname.startsWith('/request-for-changes') &&
    !pathname.startsWith('/user') &&
    !pathname.startsWith('/dealers')
  ) {
    dispatch({ type: CLEAR_SELECTED_CHANGE_REQUEST });
  }
}

function clearBidsStateIfNeed(pathname, dispatch) {
  if (!pathname.startsWith('/bids') && !pathname.startsWith('/vehicle')) {
    dispatch({ type: CLEAR_BIDS_SEARCH_PARAMS });
  }
}
